/**
 * オンラインのカード事前決済が必要かを返す。
 * 現地決済 (ONSITE) と請求書払い (INVOICE) のときだけカード不要 (false)。
 * 金額は問わない (有料の現地決済も対象。0 円 ONSITE は backend が売り切れ扱いで
 * 画面に来ない)。
 * paymentType が未確定 (undefined) / ADVANCE のときは安全側でカード必須 (true)。
 * LATER 単体は汎用の事後決済でありカード必須のまま — カード不要なのは
 * INVOICE だけ (SB-2127)。
 */
export const requiresPayment = (paymentType: string | undefined): boolean =>
  paymentType !== 'ONSITE' && paymentType !== 'INVOICE'

/**
 * 請求書払い (INVOICE) プランかを返す。カード要否 (requiresPayment) とは
 * 別の関心事: 表示文言の分岐に使う。ONSITE と INVOICE はどちらもカード不要
 * だが、ゲストへの案内 (現地でお支払い / 請求書払い) は異なる (SB-2127)。
 */
export const isInvoicePayment = (paymentType: string | undefined): boolean =>
  paymentType === 'INVOICE'

/**
 * Whether the reservation detail offers the guest a receipt (issue/download).
 * Invoice-billed (INVOICE) and post-paid (LATER) guests pay by transfer after
 * the stay, so no receipt is offered; the property issues one on request, and
 * the backend refuses both receipt endpoints for them. While paymentType is
 * still unknown it is not offered either, so the form never appears and then
 * disappears (SB-3056).
 */
export const offersGuestReceipt = (paymentType: string | undefined): boolean =>
  paymentType !== undefined &&
  paymentType !== 'INVOICE' &&
  paymentType !== 'LATER'
